import React, { useEffect, useRef, useState } from 'react';
import { Content, ContentContainer, Header, HeaderContainer, Title } from './styles';

import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md';

type AccordionProps = {
  open: boolean;
  title: string;
  onClick?: () => void;
  header?: (open: boolean, title: string) => React.ReactNode;
  titleIcon?: (open: boolean) => React.ReactNode;
  children: React.ReactNode | React.ReactNode[];
  disabled?: boolean;
};

const Accordion = (props: AccordionProps) => {
  const { title, open, header, titleIcon, children, onClick = () => {}, disabled = false } = props;

  const contentRef = useRef<HTMLDivElement>(null);

  const [contentHeight, setContentHeight] = useState(0);

  useEffect(() => {
    setContentHeight(contentRef.current?.scrollHeight || 0);
  }, [children]);

  return (
    <>
      <HeaderContainer disabled={disabled} onClick={() => (!disabled ? onClick() : () => {})}>
        {header ? (
          header(open, title)
        ) : (
          <Header>
            <Title open={open}>{title}</Title>

            {titleIcon ? titleIcon(open) : open ? <MdKeyboardArrowUp size={28} /> : <MdKeyboardArrowDown size={28} />}
          </Header>
        )}
      </HeaderContainer>

      <ContentContainer open={open} contentHeight={contentHeight}>
        <Content ref={contentRef}>{children}</Content>
      </ContentContainer>
    </>
  );
};

export default Accordion;
